import { useGlobalConfig } from "@finitless/shared/contexts";
import { useBilling } from "./useBilling";
import { isFirstLoadFeatureKey } from "../lib/subscriptionFeatures";

/**
 * Check if a subscription feature is enabled.
 * First-load features are resolved from GlobalConfigProvider (which fetches /frontends/first_load).
 * Other features fall back to billing subscriptions.
 * @param {string} featureKey - Key from SUBSCRIPTION_FEATURES constants
 * @returns {{ enabled: boolean, isLoading: boolean }}
 */
export const useSubscriptionFeature = (featureKey) => {
  const {
    isFeatureEnabled,
    isLoading: configLoading,
    isReady,
  } = useGlobalConfig();
  const { features: billingFeatures, isLoading: billingLoading } = useBilling();
  const shouldUseFirstLoad = isFirstLoadFeatureKey(featureKey);

  if (shouldUseFirstLoad) {
    if (isReady) {
      return {
        enabled: isFeatureEnabled(featureKey),
        isLoading: false,
      };
    }

    return {
      enabled: false,
      isLoading: configLoading,
    };
  }

  return {
    enabled: !!billingFeatures[featureKey],
    isLoading: billingLoading,
  };
};
